import { Chip, ChipProps } from '@mui/material';
import React, { FC } from 'react';

export interface IChip {
  item?: any;
  handleClick?: (item: any) => void;
}

export const ChipComponent: FC<ChipProps & IChip> = props => {
  const click = () => {
    props.handleClick && props.handleClick(props.item);
  };

  return <Chip {...props} onClick={click} />;
};
